import {DistrictResource} from 'app/components/tv/apiResources/DistrictResource';
import {ImageInterface} from 'app/types/ImageInterface';
import {SpecialCompetitions} from 'app/types/SpecialCompetitions';
import CompetitionResource from 'app/components/tv/apiResources/CompetitionResource';

export default class Competition {
  id: number;
  competitionSeasonId: number;
  slug: string;
  season: {
    slug: string;
    name: string;
  };
  name: string;
  middleName: string;
  shortName: string;
  active: boolean;
  ageGroup: {
    slug: string;
    name: string;
  };
  image: ImageInterface;
  district: DistrictResource;
  category: {
    id: number;
    name: string;
  };
  level: number;
  order: number;
  videoAllowed: boolean;
  standingFormUpdatedAt: number;

  constructor(data: CompetitionResource) {
    Object.assign(this, data);
  }

  getRegionSlug(): string | null {
    if (this.slug === SpecialCompetitions.Testmatches) {
      return null;
    }
    return this.district.region.slug;
  }

  getName(): string {
    return this.name + (!this.active && this.season.name ? ` ${this.season.name}` : '');
  }
}
